module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-pending-report/master-pending-report.component.scss
// module id = ./src/app/master/master-pending-report/master-pending-report.component.scss
// module chunks = main